import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, Plus } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../components/ui/dialog";

const BASE = "/dashboard/kelompok-tani/lahan";

const blockReason = (l) => {
  if (l.status === "INACTIVE") return "Lahan nonaktif";
  if (!l.published) return "Belum dipublikasikan — buka lahan lalu klik Publikasikan";
  if (!(l.remainingTrees > 0)) return "Kapasitas pohon sudah habis";
  return null;
};

const LandOption = ({ l, onPick }) => {
  const reason = blockReason(l);
  return (
    <Link to={`${BASE}/${l.id}${reason ? "" : "?buat=1"}`} onClick={onPick} data-testid={`add-project-land-${l.id}`}
      className="block rounded-lg border border-slate-200 p-3 hover:border-emerald-600/50 transition-colors">
      <p className="font-semibold text-slate-900"><span className="font-mono text-emerald-800">{l.landCode}</span> — {l.name}</p>
      <p className={`text-xs mt-0.5 ${reason ? "text-amber-700" : "text-emerald-800"}`}>
        {reason || `Sisa kapasitas ${Number(l.remainingTrees).toLocaleString("id-ID")} pohon — lanjut buat kebun`}
      </p>
    </Link>
  );
};

export const AddProjectButton = ({ className = "" }) => {
  const [open, setOpen] = useState(false);
  const [lands, setLands] = useState(null);
  useEffect(() => {
    if (open) api.get("/lands").then((r) => setLands(r.data)).catch((e) => { toast.error(formatApiError(e)); setLands([]); });
  }, [open]);
  return (
    <>
      <Button onClick={() => setOpen(true)} className={`h-12 px-6 rounded-full bg-emerald-800 hover:bg-emerald-900 font-bold ${className}`} data-testid="add-project-btn">
        <Plus className="h-5 w-5 mr-1.5" />TAMBAH RENCANA KEBUN
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-h-[90vh] overflow-y-auto" data-testid="add-project-dialog">
          <DialogHeader><DialogTitle>Pilih Lahan untuk Rencana Kebun Baru</DialogTitle></DialogHeader>
          <p className="text-sm text-slate-600">Setiap kebun dibuat dari lahan yang sudah didaftarkan, agar luas, kapasitas pohon, dan area di peta tidak tumpang tindih.</p>
          {!lands ? <div className="py-8 grid place-items-center"><Loader2 className="h-5 w-5 animate-spin text-emerald-700" /></div> : (
            <div className="space-y-2" data-testid="add-project-land-list">
              {lands.map((l) => <LandOption key={l.id} l={l} onPick={() => setOpen(false)} />)}
              {!lands.length && <p className="text-sm text-slate-500" data-testid="add-project-no-land">Belum ada lahan terdaftar. Daftarkan lahan terlebih dahulu.</p>}
            </div>
          )}
          <Link to={`${BASE}/baru`} onClick={() => setOpen(false)} className="inline-flex h-10 items-center justify-center rounded-full border border-emerald-800 px-4 text-sm font-semibold text-emerald-800" data-testid="add-project-new-land-link">
            + Daftarkan Lahan Baru
          </Link>
        </DialogContent>
      </Dialog>
    </>
  );
};
